import React from 'react';
import './PageTransition.css';

function PageTransition({ children }) {
  return (
    <div className="page-transition">
      {children}
    </div>
  );
}

export default PageTransition;